import styles from './CommunauteDataIAHeader.module.css'
import logoCommunauteDataIA from '../../../../assets/images/Logo_Communaute_DATA_IA.png'

const CommunauteDataIAHeader = () => (
  <header className={styles.header}>
    <img
      className={styles.image}
      src={logoCommunauteDataIA}
      alt="Communauté DATA & IA"
    />
  </header>
)

export default CommunauteDataIAHeader
